import React, { useState } from "react";
import {
  DislikeFilled,
  LikeFilled,
  LikeOutlined,
  DislikeOutlined,
} from "@ant-design/icons";
import { Button, Input, message, Radio } from "antd";
import Icons from "Common/Icons";
import api from "utils/api";
import { useTranslation, Trans } from "react-i18next";
import { CONSTANTS } from "utils/constant";
import { PRIMARY_LANG, LANG_STYLD_EXT, TS_STYLD_COMPS } from "Common/constant";

const ChatFeedback = ({ chatId, handleClose, includePrimeLang }) => {
  const [feedbackRating, setFeedbackRating] = useState(null);
  const [feedbackComment, setFeedbackComment] = useState();

  const handleFeedbackChange = (value) => {
    if (feedbackRating != value) {
      setFeedbackRating(value);
    } else {
      setFeedbackRating(null);
    }
  };

  const handleFeedBackCmntChange = (value) => {
    setFeedbackComment(value);
  };
  const { t, i18n } = useTranslation();
  const tgtLang = includePrimeLang
    ? i18n.language + "_" + PRIMARY_LANG
    : i18n.language;
  const tgtLangST = includePrimeLang ? tgtLang + LANG_STYLD_EXT : tgtLang;

  const handleFeedbackSubmit = () => {
    let data = {
      chat_id: chatId,
      is_feedback: true,
      feedback_rating: feedbackRating ?? null,
      feedback_comment: feedbackComment ? feedbackComment.trim() : "",
    };

    api
      .send_chat_bot_feedback(data)
      .then((res) => {
        if (res.data?.status == 200) {
          message.success(res.data?.message , ErrorDuration);
        }
        handleClose();
      })
      .catch((err) => {
        message.error("Something went wrong" , ErrorDuration);
        handleClose();
      });
  };

  return (
    <div>
      <div className="chatPopupContent">
        <div className="feedbackContent0">
          <div className="feedbackContent">
            <div className="feedbackContent1">
              <p><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.TELL_US_RATE_SERVICE,{lng:tgtLangST})}</Trans></p>
              <Radio.Group
                onChange={(e) => handleFeedbackChange(e.target.value)}
                className="thumbsButton"
              >
                <Radio.Button value="positive" className="thumbs">
                  {feedbackRating === "positive" ? (
                    <img src={Icons.thumbs_up_green} />
                  ) : (
                    <img src={Icons.thumbs_up_gray} />
                  )}
                </Radio.Button>
                <Radio.Button value="negative" className="thumbs">
                  {feedbackRating === "negative" ? (
                    <img src={Icons.thumbs_down_red} />
                  ) : (
                    <img src={Icons.thumbs_down_gray} />
                  )}
                </Radio.Button>
              </Radio.Group>
            </div>
            <Input.TextArea
              value={feedbackComment}
              onChange={(event) => handleFeedBackCmntChange(event.target.value)}
              className="txtarea"
              size="middle"
              placeholder={t(CONSTANTS.ADD_COMMENTS,{lng:tgtLang})}
              // autoSize
              style={{maxHeight:"300px", height:"60px",marginTop:"12px"}}
              rows={4}
            ></Input.TextArea>
          </div>

          <div className="feedbackBtns">
            <Button onClick={handleClose} className="fdbk-close-btn">
            <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.CLOSE,{lng:tgtLangST})}</Trans>
            </Button>
            <Button
              className="fdbk-submit-btn"
              disabled={!feedbackRating && !feedbackComment?.trim()}
              onClick={handleFeedbackSubmit}
            >
             <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.SUBMIT,{lng:tgtLangST})}</Trans>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatFeedback;
